import { MDSText, MDSTextColor, MDSTextVariant, MDSTextWeight } from "@/mds/components/text";
import { UsageProgress } from "@/pages/settings/usage-progress";
import {
  MDSPlanCard,
  MDSPlanCardSlot,
  MDSPlanCardBackground,
  MDSPlanCardBorder,
  MDSPlanId,
  MDSIconKind,
} from "@/mds";
import { BillingStrategyEnum } from "@/store/pages/SettingsSubscriptionManagementPageStore/types";
import { MDSBadge, MDSBadgeVariant } from "@/mds/components/badge";
import { MDSButton, MDSButtonVariant } from "@/mds/components/buttons";
import { MDSIcon } from "@/mds/components/icon";
import {
  freeFeatures,
  proFeatures,
} from "@/pages/settings/components/subscription-management/data";
import styled from "@emotion/styled";
import {
  CardsRow,
  TitleAndBadgeContainer,
} from "@/pages/settings/components/subscription-management/subscription.styles";

interface Props {
  renewalDateText: string;
  onSubscribe: (billingStrategy: BillingStrategyEnum) => void;
}

export const PaidPlanManagement: React.FC<Props> = ({
  renewalDateText,
  onSubscribe: handleSubscribe,
}) => {
  return (
    <>
      <TitleAndBadgeContainer>
        <MDSText variant={MDSTextVariant.HeaderL} color={MDSTextColor.Contrast}>
          Free Plan
        </MDSText>
        <MDSBadge
          label="Upgrade"
          variant={MDSBadgeVariant.EmphasisBig}
          icon={MDSIconKind.StarSolid}
        />
      </TitleAndBadgeContainer>
      <PlanContainer>
        <MDSText>Monthly limits will reset on {renewalDateText}</MDSText>
        <UsageProgress />

        <CardsRow $columns>
          {/* Free plan card */}
          <MDSPlanCard
            plan={MDSPlanId.Free}
            features={freeFeatures}
            border={MDSPlanCardBorder.Default}
            background={MDSPlanCardBackground.Default}
          >
            <MDSText
              variant={MDSTextVariant.HeaderL}
              weight={MDSTextWeight.SemiBold}
              slot={MDSPlanCardSlot.Title}
            >
              Free
            </MDSText>
            <MDSBadge
              label="Current"
              variant={MDSBadgeVariant.Default}
              slot={MDSPlanCardSlot.TitleBadge}
            />

            <div slot={MDSPlanCardSlot.Price}>$0 forever</div>
          </MDSPlanCard>

          <MDSPlanCard
            plan={MDSPlanId.Paid}
            features={proFeatures}
            border={MDSPlanCardBorder.Emphasis}
            background={MDSPlanCardBackground.Emphasis}
          >
            <MDSText
              variant={MDSTextVariant.HeaderL}
              weight={MDSTextWeight.SemiBold}
              slot={MDSPlanCardSlot.Title}
            >
              Pro
            </MDSText>
            <MDSBadge
              label="Unlimited"
              variant={MDSBadgeVariant.MoreEmphasis}
              slot={MDSPlanCardSlot.TitleBadge}
            />
            <div slot={MDSPlanCardSlot.Price}>$12 / month</div>

            <MDSButton
              variant={MDSButtonVariant.Emphasis}
              onClick={() => handleSubscribe(BillingStrategyEnum.MONTHLY)}
              slot={MDSPlanCardSlot.Footer}
            >
              <MDSIcon kind={MDSIconKind.StarSolid} /> Upgrade to Pro
            </MDSButton>
          </MDSPlanCard>
        </CardsRow>
      </PlanContainer>
    </>
  );
};

const PlanContainer = styled.div`
  padding: ${({ theme }) => theme.spacing[2]} 0;
`;
